<template>
  <div class="gotop-box">
    <!-- 在线客服 -->
    <div id="online-service" @click="toService">
      <div class="online-service-txt">
        <span class="online-service-img"> </span>
        <span style="font-size: 12px">在线客服</span>
      </div>
    </div>
    <!-- app -->
    <div id="app" @click="toApp">
      <div class="app-txt">
        <span class="app-img"> </span>
        <span style="font-size: 12px">APP下载</span>
      </div>
    </div>
    <!-- 小程序 -->
    <div id="uniapp">
      <div class="uniapp-txt">
        <span class="uniapp-img"> </span>
        <span style="font-size: 12px">紧固达小程序</span>
      </div>
      <!-- <div class="icon-img">
        <img src="@/assets/img/shichuang/weixin-uniapp.jpg" alt="" />
      </div> -->
    </div>
    <!-- 回到顶部 -->
    <div
      id="GoTop"
      :class="{ visible: visible }"
      role="button"
      tabindex="0"
      aria-label="回到顶部"
      @click="scrollToTop"
      @keydown.space.prevent="scrollToTop"
      @keydown.enter.prevent="scrollToTop"
    >
      <div class="gotop-txt">
        <span
          style="margin-bottom: 10px"
          class="glyphicon glyphicon-chevron-up"
          aria-hidden="true"
        ></span>
        <span style="font-size: 12px">返回顶部</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      visible: false,
      ticking: false,
    };
  },
  methods: {
    scrollToTop() {
      const duration = 600;
      const start =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      if (start === 0) return;
      const startTime = performance.now();

      const step = (now) => {
        const t = Math.min(1, (now - startTime) / duration);
        const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
        const y = Math.ceil(start * (1 - eased));
        window.scrollTo(0, y);
        if (t < 1) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    },
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.visible =
          (window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0) > 200;
        this.ticking = false;
      });
    },
    // 去下载app
    toApp() {
      console.log("点击了下载app");
    },
    // 去在线客服
    toService() {
      console.log("点击了在线客服");
    },
  },
  mounted() {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", this.onScroll, { passive: true });
      // 初始化状态
      this.onScroll();
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("scroll", this.onScroll);
    }
  },
};
</script>
<style scoped>
.gotop-box {
  position: fixed;
  right: 20px;
  bottom: 120px;
  z-index: 99999999;
  cursor: pointer;
  text-align: center;
  background-color: #abafb2;
  color: #fff;
}

/* 在线客服 */
#online-service {
  position: relative;
  border-bottom: 1px solid #fff;

  .online-service-txt {
    width: 100px;
    height: 100px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    justify-items: center;
    flex-direction: column;

    .online-service-img {
      background: url("../assets/img/shichuang/service.png") no-repeat center
        center;
      width: 48px;
      height: 48px;
      margin-bottom: 10px;
    }

    & > span {
      display: block;
      font-weight: bold;
      font-size: 30px;
    }

    &:hover {
      color: #f86e0b;
    }

    &:hover .online-service-img {
      background-image: url("../assets/img/shichuang/setService.png");
    }
  }
}

/* app */
#app {
  position: relative;
  border-bottom: 1px solid #fff;

  .app-txt {
    width: 100px;
    height: 100px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    justify-items: center;
    flex-direction: column;

    .app-img {
      background: url("../assets/img/shichuang/app.png") no-repeat center center;
      width: 48px;
      height: 48px;
      margin-bottom: 10px;
    }

    & > span {
      display: block;
      font-weight: bold;
      font-size: 30px;
    }

    &:hover {
      color: #f86e0b;
    }

    &:hover .app-img {
      background-image: url("../assets/img/shichuang/setApp.png");
    }
  }
}

/* 小程序 */
#uniapp {
  position: relative;
  border-bottom: 1px solid #fff;

  .uniapp-txt {
    width: 100px;
    height: 100px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    justify-items: center;
    flex-direction: column;

    .uniapp-img {
      background: url("../assets/img/shichuang/weixin.png") no-repeat center
        center;
      width: 48px;
      height: 48px;
      margin-bottom: 10px;
    }

    & > span {
      display: block;
      font-weight: bold;
      font-size: 30px;
    }

    &:hover {
      color: #f86e0b;
    }

    &:hover .uniapp-img {
      background-image: url("../assets/img/shichuang/setWeixin.png");
    }
  }

  .icon-img {
    display: none;
    position: absolute;
    right: 100px;
    top: 0;
  }

  &:hover .icon-img {
    display: block;
  }
}

/* 回到顶部 */
#GoTop {
  .gotop-txt {
    width: 100px;
    height: 100px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    justify-items: center;
    flex-direction: column;

    & > span {
      display: block;
      font-weight: bold;
      font-size: 30px;
    }

    &:hover {
      color: #f86e0b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue